export default "__VITE_ASSET__02464145__"